import {
  fetchGetFlatTourBookingSchedule,
  TGetFlatTourBookingScheduleResponse,
} from '../../../shared/repositories/newbuilding-flat-tour-booking/v1/get-flat-tour-booking-schedule';
import { getIsFlatViewOrderEnabled, getNewbuildingId } from '../../../shared/selectors/newbuilding';
import { transformFlatTourBooking } from '../../../shared/mappers/transformFlatTourBooking';
import { isValidFlatTourSchedule } from '../../../shared/utils/flatTourSchedule';
import { setScheduleData } from '../../../shared/slices/flatTourBookingReducer';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../../shared/types/redux';

export const getFlatTourSchedule = createAsyncThunk<void, void, IThunkApi>(
  'flatTourBooking/getFlatTourSchedule',
  async (_, thunkApi) => {
    const {
      dispatch,
      getState,
      extra: { logger, httpApi },
    } = thunkApi;

    try {
      const isTourEnabled = getIsFlatViewOrderEnabled(getState());

      if (!isTourEnabled) {
        return;
      }

      const newbuildingId = getNewbuildingId(getState());

      const response: TGetFlatTourBookingScheduleResponse = await fetchGetFlatTourBookingSchedule({
        httpApi,
        parameters: { newbuildingId },
      });

      if (response.statusCode !== 200) {
        throw response.response.message;
      }

      if (!isValidFlatTourSchedule(response.response.schedule)) {
        throw new Error(`Ошибка валидации ISchedule в getFlatTourSchedule`);
      }

      const preparedData = transformFlatTourBooking(response.response.schedule);
      dispatch(setScheduleData(preparedData));
    } catch (error) {
      logger.error(error, {
        domain: 'getFlatTourSchedule',
      });
    }
  },
);
